import React, { useState } from "react";
import { arrColors } from './Arrays';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import SecondStep from './SecondStep';
import Results from "./Results";
import FirstStep from "./FirstStep";
import next from '../assets/images/next.svg';
import reset from '../assets/images/reset.svg';
import hdrweak from '../assets/images/hdrweak.svg';
import { useTranslation } from "react-i18next";


const useStyles = makeStyles(theme => ({
  button: {
    margin: theme.spacing(1),
  },
  input: {
    display: 'none',
  },
}));

const Board = () => {

  const { t } = useTranslation();
  const arrCo = [].concat(arrColors);
  const classes = useStyles();
  const nActive = 96;
  const [colors, updateArrColors] = useState(arrCo);
  const [currentActive, updateDotActive] = useState(nActive);
  const [dotsIni, updateDotsIni] = useState([]);
  const [dotsFirstStep, updateDotsFirstStep] = useState([]);
  const [dotsSecondStep, updateDotsSecondStep] = useState([]);
  const [isSecondStep, updateIsSecondStep] = useState(false);
  const [sendInfo, updateSendInfo] = useState(false);

  const handleLoadColor = (value) => {
    const colorado = selectColor();
    updateDotActive(currentActive - 1);
    dotsFirstStep[value] = colorado;
    updateDotsFirstStep(dotsFirstStep);
  };

  const removeColorFromArray = (value) => {
    colors.splice(value, 1);
    updateArrColors(colors);
  }

  const selectColor = () => {
    const cArr = colors[Math.floor(Math.random() * colors.length)];
    let sColor = cArr;
    removeColorFromArray(colors.indexOf(cArr));
    return sColor;
  }

  const resetAll = () => {
    updateDotsFirstStep([]);
    updateDotActive(nActive);
    updateArrColors(arrCo);
  }

  const nextStep = (value) => {

    if (value.length === nActive) {
      updateIsSecondStep(true);
      updateDotsIni(value);
    }

    let arrSS = [];

    for (var i = 0, l = dotsFirstStep.length; i < l; i++) {
      arrSS.push(dotsFirstStep[i]);
    }
    updateDotsSecondStep(arrSS);
  }

  const handleUnLoadColor = (value) => {
    dotsSecondStep[value] = null;
    updateDotsSecondStep(dotsSecondStep);
    updateDotsFirstStep([]);
  }

  const sendDots = () => {
    updateSendInfo(true);

  }

  return (
    <div className="mt-3">
      <div className="text-center">

        {!isSecondStep ?
          <div>
            <FirstStep currentActive={currentActive} dotsFirstStep={dotsFirstStep} handleLoadColor={handleLoadColor} />
          </div>
          :
          <div>
            {!sendInfo ?
              <SecondStep dotsSecondStep={dotsSecondStep} handleUnLoadColor={handleUnLoadColor} />
              : null}
          </div>
        }
      </div>
      <div className="text-center">
        {!isSecondStep ?
          <div>
            <Button variant="contained" className={classes.button} onClick={() => resetAll([])}>
              {t('reset')} <img className="mx-1" src={reset} alt="reset" />
            </Button>

            {currentActive === 0 ?
              <Button variant="contained" className={classes.button} onClick={() => nextStep(dotsFirstStep)}>
                {t('next')} <img className="mx-1" src={next} alt="next" />
              </Button> : null} </div> : null}

        {!sendInfo && isSecondStep ?
          <Button variant="contained" className={classes.button} onClick={() => sendDots()}>
            {t('preview')} <img className="mx-1" src={hdrweak} alt="preview" />
          </Button>
          : null
        }

        {sendInfo ?
          <Results dotsFirstStep={dotsIni} dotsSecondStep={dotsSecondStep} /> : null
        }

      </div>
    </div>
  );
}

export default Board;